export default __webpack_public_path__ + "static/media/background.c221a855.svg";